// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-lined-card[data-v-7d9904aa]{position:relative}p[data-v-7d9904aa]{margin-bottom:0}.content[data-v-7d9904aa]{font-size:.875rem;color:#828282}.dietary-labels[data-v-7d9904aa]{position:absolute;top:10px;right:10px;z-index:1;max-width:100%}ul[data-v-7d9904aa]{list-style:none;margin:0;padding:0;display:flex;align-items:center}li[data-v-7d9904aa]{margin-left:6px}.dietary-label-icon[data-v-7d9904aa]{height:16px;width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
